import { createBrowserRouter, Navigate } from "react-router-dom";
import { AuthGuard } from "~/features/auth/guards/AuthGuard";
import { useCurrentUser } from "~/features/auth/hooks/use-current-user";
import { AnalysisDraftPage } from "~/pages/analysis-draft/AnalysisDraftPage";
import { BranchManagementPage } from "~/pages/branch-management/BranchManagementPage";
import { CameraMappingPage } from "~/pages/camera-mapping/CameraMappingPage";
import { LoginPage } from "~/pages/login/LoginPage";
import { NotFoundPage } from "~/pages/not-found/NotFoundPage";
import { ResourceManagementPage } from "~/pages/resource-management/ResourceManagementPage";
import { VersionManagementPage } from "~/pages/version-management/VersionManagementPage";
import { AppLayout } from "~/widgets/layout/AppLayout";
import { WorkflowLayout } from "~/widgets/layout/WorkflowLayout";
import { LegacyRedirect } from "./LegacyRedirect";

function BranchIndexRedirect() {
  const { data: currentUser, isPending } = useCurrentUser();
  // 콜드 로드(새로고침·딥링크) 시 유저 정보(staff 여부)가 도착하기 전에
  // 리다이렉트하면 staff 도 비-staff 기본값으로 떨어진다. 도착할 때까지 대기.
  if (isPending) return null;
  const target = currentUser?.isStaff ? "resources" : "camera-mapping";
  return <Navigate to={target} replace />;
}

const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },

  // 레거시 URL 리다이렉트
  { path: "/branches", element: <Navigate to="/" replace /> },
  {
    path: "/space-identify",
    element: <LegacyRedirect to="/branch/:branchUid/camera-mapping" />,
  },
  {
    path: "/analysis-sketch",
    element: <LegacyRedirect to="/branch/:branchUid/analysis-draft" />,
  },
  {
    path: "branch/list",
    element: <Navigate to="/" replace />,
  },
  {
    path: "branch/:branchUid/camera-matching",
    element: <LegacyRedirect to="/branch/:branchUid/camera-mapping" />,
  },
  {
    path: "branch/:branchUid/analysis",
    element: <LegacyRedirect to="/branch/:branchUid/analysis-draft" />,
  },
  {
    path: "branch/:branchUid/camera-view/add",
    element: <Navigate to="/" replace />,
  },

  {
    element: <AuthGuard />,
    children: [
      {
        path: "/",
        element: <AppLayout />,
        children: [{ index: true, element: <BranchManagementPage /> }],
      },
      {
        path: "/branch/:branchUid",
        element: <WorkflowLayout />,
        children: [
          { path: "resources", element: <ResourceManagementPage /> },
          { path: "camera-mapping", element: <CameraMappingPage /> },
          { path: "analysis-draft", element: <AnalysisDraftPage /> },
          { path: "versions", element: <VersionManagementPage /> },
          { index: true, element: <BranchIndexRedirect /> },
        ],
      },
    ],
  },

  // 매칭되는 라우트가 없을 때(오타·만료된 링크 등) 404 페이지
  { path: "*", element: <NotFoundPage /> },
]);

export default router;
